import StarColor from './StarColour.svg';
import StarDark from './StarDark.svg';
import StarLight from './StarLight.svg';
export const star = { color: StarColor, dark: StarDark, light: StarLight };
//# sourceMappingURL=index.js.map